module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('sub-ibox-title', {
    attrs: {
      "is-show-back": true
    }
  }, [_c('p', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.params.id ? '编辑' : '新增') + "轮播")])]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "detail-cont"
  }, [_c('div', {
    staticClass: "fx fx-y-center m-t-15"
  }, [_vm._m(0), _vm._v(" "), _c('z-upload', {
    attrs: {
      "file-url": _vm.params.pic,
      "on-success": _vm.handleUploadSuccess
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pic-tips m-l-10"
  }, [_vm._v("建议尺寸：640*300；文件大小建议300KB以内")])], 1), _vm._v(" "), _c('z-input', {
    staticClass: "m-t-15",
    attrs: {
      "title": "点击跳转链接",
      "placeholder": "地址请带上http://或者https://"
    },
    model: {
      value: (_vm.params.url),
      callback: function($$v) {
        _vm.$set(_vm.params, "url", $$v)
      },
      expression: "params.url"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "m-t-30 fx"
  }, [_c('p', {
    staticClass: "w120 m-r-5 fx-shrink"
  }), _vm._v(" "), _c('a', {
    staticClass: "z-btn z-btn-primary b-r-3",
    on: {
      "click": _vm.handleSave
    }
  }, [_vm._v("保存")])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title fx w120 m-r-5"
  }, [_c('p', {
    staticClass: "ask-cont"
  }, [_c('i', {
    staticClass: "ask"
  }, [_vm._v("*")])]), _c('span', {
    staticClass: "fx-fill"
  }, [_vm._v("轮播图 ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-1dc38fa4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/mp/vmall/BannerEdit.vue
// module id = 825
// module chunks = 0